import { render, staticRenderFns } from "./despatch-order-list.vue?vue&type=template&id=a31ac91a"
import script from "./despatch-order-list.vue?vue&type=script&lang=js"
export * from "./despatch-order-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports